import { SharedIcon } from "./shared-icon";

export function LoadingContent() {
  return (
    <div className="saved-colors-loading-container">
      <SharedIcon iconName="#sprite-spinner" className="animate-spin" />
    </div>
  );
}
